import Http from '@/utils/http'
import { TOKEN, USER_ID } from '../utils/'
import {
  LOGIN,
  REGISTRATION,
  VERIFY_TOKEN,
  ACCOUNT_ME
} from './urls'
import router from '../router/index'
import Cookies from '../utils/cookies'

export const login = (data) => Http.post(LOGIN, data)

export const storeAuthentication = (credentials, token, data) => {
  const expiredAt = new Date()
  // Set Time&Expiry Date to 2days
  expiredAt.setTime(expiredAt.getTime() + (2 * 24 * 60 * 60 * 1000))
  // Create new Cookie
  Cookies.setCookie(TOKEN, token, expiredAt)
  Cookies.setCookie(USER_ID, credentials.username, expiredAt)
  Cookies.setCookie('witch', data.is_superuser, expiredAt)
  Cookies.setCookie('staff', data.is_staff, expiredAt)
  Http.defaults.headers.common.Authorization = `JWT ${token}`
}

export const getAuthorizationHeader = () => {
  return `JWT ${Cookies.getCookieName(TOKEN)}`
}

export function tokenVerification (currentCookieToken) {
  return Http.post(VERIFY_TOKEN, { token: currentCookieToken })
}

export const isAuthenticated = () => {
  const currentCookieToken = Cookies.getCookieName(TOKEN)
  if (currentCookieToken) {
    return this.tokenVerification(currentCookieToken)
  }
  // navigate to the login page if the cookie is not found
  return Promise.reject(new Error('User is not logged in'))
}
export const logout = () => {
  if (Cookies.checkCookie(TOKEN)) {
    Cookies.removeCookie(TOKEN)
    Cookies.removeCookie('witch')
    Cookies.removeCookie('staff')
    router.push('/')
  } else {
    router.push('/')
  }
}

export const getUserInfo = (isAdmin) => {
  if (!Cookies.checkCookie(TOKEN)) {
    return Promise.reject(new Error('Not authentitcated'))
  }
  return Http.get(`${ACCOUNT_ME}?check-admin=${isAdmin}`)
}

export const register = (data) => {
  return Http.post(REGISTRATION, data)
}

export const isUserAuthenticated = (paths) => {
  const checkAdmin = paths.some(path => path.meta.requiredAdmin)
  return getUserInfo(checkAdmin)
}

export const hasPermission = (permissions, permissionToCheck) => {
  if (permissions.length < 0) {
    return false
  }
  /* eslint-disable */
  for (const p in permissions) {
    const perm = permissions[p];
    // console.log('Checking',perm);
    if (perm.codename === permissionToCheck) {
      return true;
    }
  }
  return false;
}





// WEBPACK FOOTER //
// ./src/services/auth.js